import type { FiscalEventItem } from '@/services/api';
import { shortenDetailJson } from './fiscalFormat';

/** Shared event-history list for the invoice/receipt detail dialogs — kind + timestamp + a
 *  truncated one-line rendering of detailJson (full JSON on hover via the title attribute). */
export function FiscalEventTimeline({
  events,
  title,
  emptyLabel,
}: {
  events: FiscalEventItem[];
  title: string;
  emptyLabel: string;
}) {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">{title}</p>
      {events.length === 0 ? (
        <p className="text-muted-foreground text-sm">{emptyLabel}</p>
      ) : (
        <div className="space-y-1.5">
          {events.map((e) => {
            const detail = shortenDetailJson(e.detailJson);
            return (
              <div key={e.id} className="bg-muted/40 rounded-md border px-3 py-1.5 text-xs">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-medium">{e.kind}</span>
                  <span className="text-muted-foreground tabular-nums">
                    {new Date(e.at).toLocaleString('pl-PL')}
                  </span>
                </div>
                {detail && (
                  <p className="text-muted-foreground mt-0.5 truncate font-mono" title={detail}>
                    {detail}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
